SNIPPETS

<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <b-modal
            v-model="showModal"
            title="Upload Files"
            centered
            hide-footer
            ok-only
            ok-title="Done"
            @hide="handleHide"
            @hidden="handleHidden"
        >
            <b-overlay :show="showSuccess">
                <template #overlay>
                    <div class="text-center">
                        <b-icon icon="check-circle" variant="success" font-scale="3"></b-icon>
                        <h4 class="mt-3">{{ successMsg }}</h4>
                    </div>
                </template>
                <FormulateForm
                    class="base-s3-file-modal-form"
                    #default="{ hasErrors }"
                    @submit="handleSubmit"
                >
                    <FormulateInput
                        id="base-s3-file-modal-formulate-file-input"
                        ref="formulateFileInput"
                        type="file"
                        name="uploads"
                        label="Drag-and-drop files below:"
                        label-hide-required
                        :element-class="['w-100', 'mw-100']"
                        :upload-area-class="['base-s3-file-modal-upload-area']"
                        :upload-area-mask-class="['bg-gray-100']"
                        :uploader="formulateUploader"
                        upload-behavior="delayed"
                        multiple
                        validation="required"
                        error-behavior="submit"
                    />
                    <FormulateInput
                        type="submit"
                        :disabled="saving || uploadPending || hasErrors"
                        :element-class="['text-center']"
                    >
                        <b-spinner small v-if="saving" key="uploading" class="mr-2"></b-spinner>
                        <b-icon v-else key="uploadReady" icon="cloud-arrow-up-fill" font-scale="1.5" class="mr-2"></b-icon>
                        <span>{{ saving ? 'Uploading' : 'Upload' }}</span>
                    </FormulateInput>
                </FormulateForm>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
// import { splFileSlinger } from '../../js/file-helpers';
import { asyncSplFileSlinger } from '../../js/file-helpers';  // NEW VERSION

export default {
    name: 'BaseS3FileModal',
    components: {},
    props: {
        fileCategory: {
            type: String,
            required: true,
        },
        parentId: {
            type: [String, Number],
            required: false,
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            showModal: false,  // v-model with modal
            showSuccess: false,
            successMsg: '', // set dynamically in submit method
            saving: false,
            formData: {},  // v-model with FormulateForm
            uploadPending: false,  // for uploading files
        }
    },
    computed: {
        hasUploadsReady: function() {
            return !!this.formData && !!this.formData.uploads && !!this.formData.uploads.files && !!this.formData.uploads.files.length;
        }
    },
    methods: {
        // PUBLIC METHODS
        startAdd: function() {
            this.showModal = true;
        },
        // PRIVATE METHODS
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        formulateUploader: function(file, progress, error, options) {
            // pass this function to 'uploader' prop of formulate-input 
            // must return a Promise that resolves to array of objects, at least with 'url' key in each object (but you also expect 'id' for your own backend handling)
            // and must accept 4 args (file, progress, error, option)
            this.uploadPending = true;  // set our flag to true so we can block things while uploading
            let file_category = this.fileCategory;
            let parentId = this.parentId;  // the ID of the 'parent' for this file - optional
            let title = '';  // you could pass title to asyncSplFileSlinger if you know it in advance
            // OLD VERSION let uploadResponse = splFileSlinger(file_category, file, progress, error, options, title, parentId);
            let uploadResponse = asyncSplFileSlinger(file_category, file, progress, error, options, title, parentId);
            let finalReturn = uploadResponse.then(resp => {
                this.uploadPending = false;
                return resp;
            });
            console.log('finalReturn from formulateUploader', finalReturn);
            return finalReturn;
        },
        handleSubmit: function(formData) {
            // this doesn't actually send anything to API -- since nothing else needs to get posted, files were already uploaded
            this.saving = true;
            let fileQty = formData.uploads.length;
            // console.log('Dumping the data that we have to post');
            // console.log(formData);
            // console.log('How many uploads?');
            // console.log(fileQty);
            this.successMsg = `Uploaded ${fileQty} File${fileQty > 1 ? 's' : ''}`
            this.showSuccess = true;
            setTimeout(() => {
                this.saving = false;
                this.showModal = false;
            }, 2000);
        },
        handleHide: function() {
            this.$emit('hide');  // used to reload list on parent
        },
        handleHidden: function() {
            this.showSuccess = false;
        }

    }
}
</script>

<style lang="scss">

.base-s3-file-modal-upload-area {
    min-height: 300px;
}

.base-s3-file-modal-form {

    button[type=submit] {
        padding-left: 40px;
        padding-right: 40px;
    }
}

</style>
